import { useContext } from "react";
import { UIContext, UIContextType } from "./UIContext";

export const useUIContext = () => useContext<UIContextType>(UIContext);
